import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button from '../../atomic/Buttons/Button';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  // background: rgba(0,0,0,0.1);
  border-bottom: 1px solid #ccc;
  margin-bottom: 8px;
  margin-right: 8px;
`

const Header = styled.div`
  font-weight: 600;
  font-size: 18px;
`

const EditHeader = ({
  label,
  onClickEdit,
  onClickCancel,
  buttonVariant,
  inEdit,
  ...other
}) => {
  return (
    <Container {...other}>
      <Header>{label}</Header>
      {
        inEdit ? (
          onClickCancel ? <Button onClick={onClickCancel} variant={buttonVariant} color="secondary">Cancel</Button> : null
        ) : (
          <Button onClick={onClickEdit} variant={buttonVariant} color="primary">Edit</Button>
        )
      }
    </Container>
  )
}

EditHeader.propTypes = {
  label: PropTypes.string,
  buttonVariant: PropTypes.string,
  onClick: PropTypes.func,
  inEdit: PropTypes.bool,
}

EditHeader.defaultProps = {
  buttonVariant: 'text',
}

export default EditHeader;
